import { useAuthContext } from 'src/hooks/auth/use-auth-context';

import { ENGAGE_APP_URL } from 'src/config-global';

/** True when Engage has an address and is switched on for the signed-in user (as for Open Engage). */
export function useEngageAccess(): boolean {
  const authContext = useAuthContext();
  return !!ENGAGE_APP_URL && authContext?.account?.engage_access === true;
}
